import { HTMLAttributes } from "react";
import classNames from "classnames";
import "./style.scss";

function A(props: HTMLAttributes<HTMLButtonElement>) {
  const { className, ...rest } = props;
  return <button className={classNames("a", className)} {...rest} />;
}

export default A;
